/** @typedef {import('./typeManagement.component').Type} Type */

import _ from 'lodash';
import template from './typeManagement.modal.component.html';

/* @ngInject */
function controller(
  $uibModalInstance,
  $scope,
  type,
  GroupService,
  GroupsButtonService,
  growl,
  Organization
) {
  const vm = this;
  vm.heading = 'New Type';
  vm.title = '';
  vm.name = '';
  vm.selectedGroups = [];
  vm.groupList = [];
  vm.model = 'resource';
  vm.formSchema = {};
  vm.formModel = {};
  vm.schemaHasKey = false;
  vm.formOptions = {
    buildFromSchema: true,
    enableBuilder: true,
    hideAdvanced: true,
    title: 'Resource Schema',
  };

  vm.$onInit = initialize;
  vm.updateName = updateName;
  vm.setupGroups = setupGroups;

  vm.editing = Boolean(type);

  if (vm.editing) {
    // TODO: Consolidate these assignments with the declarations above
    vm.heading = `Editing ${type.title}`;
    vm.title = type.title;
    vm.name = type.name;
    // TODO: updateName(); ?
    vm.description = type.description;
    vm.model = type.model;
    vm.org = type.org;
  }

  /**
   * function that's called onInit (angularJS lifecycle hook)
   *
   * @returns {undefined}
   */
  async function initialize() {
    const formSchema = _.get(type, ['formSchema'], { components: [] });
    vm.orgs = await Organization.model;
    // pluck out the inner components from the `data` container/object for user to edit schema
    // without causing a change in the resource structure
    if (formSchema.components?.length === 1 && formSchema.components[0].key === 'data') {
      formSchema.components = _.cloneDeep(formSchema.components[0].components);
    }
    vm.formSchema = formSchema;
    vm.schemaHasKey = vm.formSchema.components.some(comp => comp.unique);

    // if no formSchema, automatically show the builder
    vm.formOptions.showBuilder = _.isEmpty(formSchema.components);

    if (vm.org) {
      setupGroups();
    }
  }

  function setupGroups() {
    GroupService.getGroupByOrg(vm.org, 1).then(({ body }) => {
      vm.groupList = [body];
      if (vm.editing) {
        vm.selectedGroups = type.groups;
      }
    }).catch((error) => {
      growl.error(error, { title: 'Could not get groups for selected organization' });
    });
  }

  /**
   * Checks to see if selectedGroups is empty.
   *
   * @returns {number} - returns size of selectedGroups. Caller checks truthiness of size.
   */
  vm.validateGroups = () => _.size(GroupsButtonService.cache.selectedGroupsTree);

  /**
   * calls when the save button is pressed on the modal. Closes the modal
   *
   * @returns {undefined}
   */
  vm.save = () => {
    $uibModalInstance.close(_.assign(type, getType()));
  };

  vm.updateForm = ($event) => {
    $scope.$apply(() => {
      vm.formSchema = $event;
      vm.schemaHasKey = vm.formSchema.components.some(comp => comp.unique);
    });
  };

  /**
   * Calls when you hit the cancel or X on the modal
   *
   * @returns {undefined}
   */
  vm.dismiss = function dismiss() {
    $uibModalInstance.dismiss('closed');
  };

  /**
   * Update Type.name from Type.title
   */
  function updateName() {
    vm.name = _.camelCase(vm.title);
  }

  /**
   * calls when the save button is pressed on the modal. Closes the modal
   *
   * @returns {Type}
   */
  function getType() {
    const {
      title,
      name,
      description,
      model,
      org,
      formSchema,
    } = vm;

    // wrap the user-defined components in a `data` container/object before saving
    // reproduces the stored structure of resources, without letting a user inadvertently delete the container
    formSchema.components = [{
      key: 'data',
      label: 'data',
      hideLabel: true,
      type: 'container',
      components: formSchema.components
    }];

    return {
      title,
      name,
      description,
      model,
      org,
      formSchema,
      groups: GroupsButtonService.rebuildSelectedGroups(),
    };
  }

}

export default {
  name: 'typeManagementModal',
  template,
  controller,
  controllerAs: 'modal',
  bindings: {
    type: '<'
  }
};
